import request from '@/util/server.js'
// 首页模块

//  首页-热门供应 产品类别列表
export function getTypeList () {
  return request({
    url: '/supply/demand/type/list',
    method: 'post'
  })
}

// 首页-好货推荐
export function getProductList (params) {
  return request({
    url: '/product/getRecommendedList',
    method: 'get',
    params
  })
}

// 首页-推荐供应商
export function getShopList (params) {
  return request({
    url: '/shop/getRecommendedList',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/home/supply.js